import React from "react"
import { CONSTANTS, metaData, URLS } from "@data"

// sections
import { PageSection } from "@components/sections"

// shared
import { AddressExo, Logo, GridLines, Social } from "@shared"

// local
import FooterNav from "./FooterNav"
import Legal from "./Legal"

import Styles from "./footer.module.scss"

const { THEMES } = CONSTANTS
const { mailing } = metaData

/**
 * Main Footer Container/Wrapper
 * @param {object} props - react props
 */
// eslint-disable-next-line no-unused-vars
const Footer = props => {
  return (
    <footer className={Styles.site}>
      <GridLines theme={THEMES.LIGHT} />
      <PageSection className={Styles.footerSection}>
        <Logo
          theme={THEMES.LIGHT}
          styleClass={Styles.footerLogo}
          mono
          overrideClass="footerLogoIEOverride"
        />
        <FooterNav style={Styles} theme={THEMES.LIGHT}>
          <AddressExo data={mailing} />
          <Social parentClass={Styles.socialFooter} />
        </FooterNav>
      </PageSection>
      <PageSection className={Styles.legalSection}>
        <Legal style={Styles} data={URLS} />
      </PageSection>
    </footer>
  )
}

export default Footer
